import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import StepPage from "../pages/steps/page";
import PrivacyPolicyPage from "../pages/legal/PrivacyPolicyPage";
import DisclaimerPage from "../pages/legal/DisclaimerPage";
import CopyrightPage from "../pages/legal/CopyrightPage";
import ContactPage from "../pages/contact/ContactPage";
import ProfilePage from "../pages/profile/ProfilePage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articles/:id",
    element: <ArticlePage />,
  },
  {
    path: "/steps/:stepId",
    element: <StepPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/disclaimer",
    element: <DisclaimerPage />,
  },
  {
    path: "/copyright",
    element: <CopyrightPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/profile",
    element: <ProfilePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
